
class Rules {
  static email (address) {
    var re = /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z.]{2,}$/
    if (re.test(address)) {
      return true
    } else {
      return 'Not a valid email address'
    }
  }

  static get PASSWORDLENGTH () {
    return 8
  }

  static password (password) {
    if (password.length < this.PASSWORDLENGTH) {
      return 'Password must be at least ' + this.PASSWORDLENGTH + ' characters long'
    } else {
      return true
    }
  }

  static required (value) {
    if (value !== null && value !== '' && value !== [] && value !== undefined) {
      return true
    } else {
      return 'This field is required'
    }
  }
}

export default Rules
